module.exports = __webpack_public_path__ + "img/image1.b3f976d.svg";